import { createAction, props } from '@ngrx/store';
import { Currency } from '@qvs/core';

const prefix = '[Currencies]';

export const loadCurrenciesOnlyIfNotLoadedYet = createAction(`${prefix} load currencies only if not loaded yet`);
export const loadCurrenciesSuccess = createAction(`${prefix} load currencies success`);
export const loadCurrenciesFailure = createAction(`${prefix} load currencies failure`);
export const upsertCurrencies = createAction(`${prefix} upsert currencies`, props<{ entities: Currency[] }>());
